import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";
const initialState = {
  pathwayFilterOptions: {
    loading: false,
    data: [],
    error: null
  },
  testRuleData: {
    loading: false,
    data: [],
    error: null
  },      
  allTestRulesPayload: { 
    rule_id: [], 
    description: [], 
    trigger_code: [], 
    status: [], 
    pathway_entry: [], 
    page_number: 1, 
    page_size:10, 
    sort_by: [], 
    sort_order: [] 
  },
  allTestRulesResponse:{
    loading: false,
    data:[],
    error: null,
  },
  testRuleDelete: {
    data: null,
    error: null,
    loading: false
  },
  testRuleDetails: {
    data: null,
    error: null,
    loading: false
  },
  approveORFailRules: {
    data: null,
    error: null,
    loading: false
  },
  environmentOptions: {
    data: null,
    error: null,
    loading: false
  },
  PublishTestRuleResponse: {
    loading: false,
    data: [],
    error: null,
  },
  viewCodeAssistRulesResponse: {
    loading: false,
    data : {},
    error: null
  },
  codeAssistRuleManagmentResponse: {
    loading: false,
    data : {},
    error: null
  },
  ruleIDStatusRepsone: {
    loading: false,
    data : {},
    error: null
  }
 };


export const getAllTestRules = createAsyncThunk(
  "/getAllTestRules",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/get_all_test_rules", payload
      );
      const data = response?.data
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Error fetching test rule episodes", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Error fetching test rule episodes",
      );
    }
  },
);
export const getPathwayFilterOptions = createAsyncThunk(
  "/getPathwayFilterOptions",
  async (
    { page = 1, count = 10 } = {},
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
      const offset = (page - 1) * count + 1;

      const response = await axiosInstance.get(
        `/fetch_test_rules_pathway_entry_points?page_size=${count}&offset=${offset}`
      );

      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Error while fetching pathway options"
      );
    }
  }
);

export const deleteTestRule = createAsyncThunk(
  "/deleteTestRule",
  async (payload, 
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
        const response = await axiosInstance.post(
        "/move_RuleTo_Delete", payload
      );

      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Error delete test rule"
      );
    }
  }
);


export const getTestRuleDetails = createAsyncThunk(
  "/getTestRuleDetails",
  async (payload, 
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
        const response = await axiosInstance.post(
        "/get_rule_details", payload
      );

      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "error fetching test rule details"
      );
    }
  }
);


export const getApproveORFailRules = createAsyncThunk(
  "/getApproveORFailRules",
  async (payload, 
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
        const response = await axiosInstance.post(
        "/approve_or_fail_rules", payload
      );

      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "error fecthing test rule deatils"
      );
    }
  }
);


export const getEnvironmentOptions = createAsyncThunk(
  "/getEnvironmentOptions",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/environment_options");

      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Error fetching environment options"
      );
    }
  }
);

export const PublishTestRule = createAsyncThunk(
  "/PublishTestRule",
  async (payload, 
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
        const response = await axiosInstance.post(
        "/publish_rule", payload
      );
      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error || 
          "error publish rule failed"
      );
    }
  }
);

export const viewCodeAssistRules = createAsyncThunk(
  "/viewCodeAssistRules",
  async (payload, 
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
        const response = await axiosInstance.post(
        "/view_code_assist_rules", payload
      );
      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "error while fetching the failed test rule details"
      );
    }
  }
);
 

export const codeAssistRuleManagment = createAsyncThunk(
  "/codeAssistRuleManagment",
  async (payload, 
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post("/code_assist_rule_management", payload);
      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(
        error ||
          "error while fetching the edit test rule"
      );
    }
  }
);

export const getRuleIDStatusRepsone = createAsyncThunk(
  "/getRuleIDStatusRepsone",
  async (jobID, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `https://y0kzl1wmr9.execute-api.ap-southeast-2.amazonaws.com/dummy/get_loader_page/?job_id=${jobID}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Error while fetching pathway options"
      );
    }
  }
);

const testRuleSlicer = createSlice({
  name: "testRule",
  initialState,
  reducers: {
    setTestRuleFilters: (state, action) => {
      state.allTestRulesPayload = {
        ...state.allTestRulesPayload,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getPathwayFilterOptions.pending, (state) => {
        state.pathwayFilterOptions.loading = true;
        state.pathwayFilterOptions.error = null;
      })
      .addCase(getPathwayFilterOptions.fulfilled, (state, action) => {
        state.pathwayFilterOptions.loading = false;
        state.pathwayFilterOptions.data = action.payload;
      })
      .addCase(getPathwayFilterOptions.rejected, (state, action) => {
        state.pathwayFilterOptions.loading = false;
        state.pathwayFilterOptions.error = action.payload;
      })
      .addCase(getAllTestRules.pending, (state) => {
        state.allTestRulesResponse.loading = true;
        state.allTestRulesResponse.error = null;
      })
      .addCase(getAllTestRules.fulfilled, (state, action) => {
        state.allTestRulesResponse.loading = false;
        state.allTestRulesResponse.data = action.payload;
      })
      .addCase(getAllTestRules.rejected, (state, action) => {
        state.allTestRulesResponse.loading = false;
        state.allTestRulesResponse.error = action.payload;
      })
      .addCase(deleteTestRule.pending, (state) => {
        state.testRuleDelete.loading = true;
        state.testRuleDelete.error = null;
      })
      .addCase(deleteTestRule.fulfilled, (state, action) => {
        state.testRuleDelete.loading = false;
        state.testRuleDelete.data = action.payload;
      })
      .addCase(deleteTestRule.rejected, (state, action) => {
        state.testRuleDelete.loading = false;
        state.testRuleDelete.error = action.payload;
      })
      .addCase(getTestRuleDetails.pending, (state) => {
        state.testRuleDetails.loading = true;
        state.testRuleDetails.error = null;
      })
      .addCase(getTestRuleDetails.fulfilled, (state, action) => {
        state.testRuleDetails.loading = false;
        state.testRuleDetails.data = action.payload;
      })
      .addCase(getTestRuleDetails.rejected, (state, action) => {
        state.testRuleDetails.loading = false;
        state.testRuleDetails.error = action.payload;
      })
      .addCase(getApproveORFailRules.pending, (state) => {
        state.approveORFailRules.loading = true;
        state.approveORFailRules.error = null;
      })
      .addCase(getApproveORFailRules.fulfilled, (state, action) => {
        state.approveORFailRules.loading = false;
        state.approveORFailRules.data = action.payload;
      })
      .addCase(getApproveORFailRules.rejected, (state, action) => {
        state.approveORFailRules.loading = false;
        state.approveORFailRules.error = action.payload;
      })
      .addCase(getEnvironmentOptions.pending, (state) => {
        state.environmentOptions.loading = true;
        state.environmentOptions.error = null;
      })
      .addCase(getEnvironmentOptions.fulfilled, (state, action) => {
        state.environmentOptions.loading = false;
        state.environmentOptions.data = action.payload;
      })
      .addCase(getEnvironmentOptions.rejected, (state, action) => {
        state.environmentOptions.loading = false;
        state.environmentOptions.error = action.payload;
      })
      .addCase(PublishTestRule.pending, (state) => {
        state.PublishTestRuleResponse.loading = true;
        state.PublishTestRuleResponse.error = null;
      })
      .addCase(PublishTestRule.fulfilled, (state, action) => {
        state.PublishTestRuleResponse.loading = false;
        state.PublishTestRuleResponse.data = action.payload;
      })
      .addCase(PublishTestRule.rejected, (state, action) => {
        state.PublishTestRuleResponse.loading = false;
        state.PublishTestRuleResponse.error = action.payload;
      })
      .addCase(viewCodeAssistRules.pending, (state) => {
        state.viewCodeAssistRulesResponse.loading = true;
        state.viewCodeAssistRulesResponse.error = null;
      })
      .addCase(viewCodeAssistRules.fulfilled, (state, action) => {
        state.viewCodeAssistRulesResponse.loading = false;
        state.viewCodeAssistRulesResponse.data = action.payload;
      })
      .addCase(viewCodeAssistRules.rejected, (state, action) => {
        state.viewCodeAssistRulesResponse.loading = false;
        state.viewCodeAssistRulesResponse.error = action.payload;
      })
      .addCase(codeAssistRuleManagment.pending, (state) => {
        state.codeAssistRuleManagmentResponse.loading = true;
        state.codeAssistRuleManagmentResponse.error = null;
      })
      .addCase(codeAssistRuleManagment.fulfilled, (state, action) => {
        state.codeAssistRuleManagmentResponse.loading = false;
        state.codeAssistRuleManagmentResponse.data = action.payload;
      })
      .addCase(codeAssistRuleManagment.rejected, (state, action) => {
        state.codeAssistRuleManagmentResponse.loading = false;
        state.codeAssistRuleManagmentResponse.error = action.payload;
      })
      .addCase(getRuleIDStatusRepsone.pending, (state) => {
        state.ruleIDStatusRepsone.loading = true;
        state.ruleIDStatusRepsone.error = null;
      })
      .addCase(getRuleIDStatusRepsone.fulfilled, (state, action) => {
        state.ruleIDStatusRepsone.loading = false;
        state.ruleIDStatusRepsone.data = action.payload;
      })
      .addCase(getRuleIDStatusRepsone.rejected, (state, action) => {
        state.ruleIDStatusRepsone.loading = false;
        state.ruleIDStatusRepsone.error = action.payload;
      })
});

export const { setTestRuleFilters
 
} = testRuleSlicer.actions;

export default testRuleSlicer.reducer;
